import {
  ConnectConfigurationKeys,
  ConnectConfigurations,
  getValueFromConfigState,
  NAMESPACE_CONNECT,
  selectConfigurationsState,
} from '@epicuro-next/platform/configuration';
import {
  createSelector,
  createSelector as fromConnectDataSelectors,
} from '@ngrx/store';

import { connectDataFeatureKey } from '../reducers/connect-data.reducer';

import { selectConnectState } from './../store';

export const selectConnectDataState = fromConnectDataSelectors(
  selectConnectState,
  (state) => state[connectDataFeatureKey],
);

/**
 * Returns user connection status
 */
export const selectUserConnectionStatus = fromConnectDataSelectors(
  selectConnectDataState,
  (state) => state.userConnectionStatus,
);

/**
 * Returns twilio token and room
 */
export const selectConnectParams = fromConnectDataSelectors(
  selectConnectDataState,
  (state) => ({
    token: state.twilioToken,
    room: state.twilioRoom,
  }),
);

/**
 * Returns loading status
 */
export const selectVideoLoadingState = fromConnectDataSelectors(
  selectConnectDataState,
  (state) => state.videoLoading,
);

/**
 * Returns the contact calling
 */
export const selectIncomingCall = fromConnectDataSelectors(
  selectConnectDataState,
  (state) => state.incomingCall,
);

/**
 * Returns the notification permission
 */
export const selectNotificationsPermission = fromConnectDataSelectors(
  selectConnectDataState,
  (state) => state.notificationPermission,
);

/**
 * Returns the call decline reason
 */
export const selectDeclineReason = fromConnectDataSelectors(
  selectConnectDataState,
  (state) => state.declineReason,
);

/**
 * Returns if connect is enabled
 */
export const selectIsConnectEnabled = fromConnectDataSelectors(
  selectConnectDataState,
  (state) => state.connectEnabled,
);

export const selectConnectIsEnabled = createSelector(
  selectConfigurationsState,
  (config) => {
    return getValueFromConfigState<
      ConnectConfigurationKeys.ConnectEnabled,
      ConnectConfigurations
    >(
      config,
      NAMESPACE_CONNECT,
      ConnectConfigurationKeys.ConnectEnabled,
      false,
    );
  },
);
